<template>
    <div class="animated fadeIn">
        <b-row>
            <b-col lg="12">
                <b-card>
                    <div slot="header">
                        <strong>{{ title }}</strong>
                    </div>
                    <b-form @submit.prevent="search">
                        <b-row>
                            <b-col sm="6">
                                <b-form-group label="Phần mềm đồng bộ:"
                                              :label-cols-md="4"
                                              :horizontal="true"
                                              label-align="left">
                                    <sync-data-source :cached="true" v-model="searchForm.syncSourceType" allowClear="true"></sync-data-source>
                                </b-form-group>
                            </b-col>
                            <b-col sm="6" v-if="searchForm.syncSourceType">
                                <b-form-group label="Đơn vị đồng bộ:"
                                              label-for="input-unit"
                                              :label-cols-md="4"
                                              :horizontal="true"
                                              label-align="left">
                                    <unit-tree :cached="true" v-model="searchForm.syncUnitId" :syncSourceType="searchForm.syncSourceType" ref="unitTree" :allowTraversal="showUnitOption" :traversalOption.sync="searchForm.unitTraversalOption"></unit-tree>
                                </b-form-group>
                            </b-col>
                        </b-row>
                        <b-row>
                            <b-col sm="6">
                                <b-form-group label="Mẫu báo cáo:"
                                              class="select2-form-group"
                                              :label-cols-md="4"
                                              :horizontal="true"
                                              label-align="left">
                                    <select2 v-model="searchForm.reportType" :options="listReportSyncTypes"
                                             placeholder="--- Tất cả ---"
                                             allowClear="true"
                                             style="width:100%"></select2>
                                </b-form-group>
                            </b-col>
                            <!--<b-col sm="6">
                                <b-form-group label="Hành vi:"
                                              :label-cols-md="4"
                                              :horizontal="true"
                                              label-align="left">
                                    <select2 v-model="searchForm.syncActionType" :options="listActions"
                                             style="width:100%"
                                             allowClear="true"
                                             placeholder="--- Tất cả ---"></select2>
                                </b-form-group>
                            </b-col>-->

                            <b-col sm="6" v-if="showStatusOption">
                                <b-form-group label="Trạng thái đồng bộ:"
                                              :label-cols-md="4"
                                              :horizontal="true"
                                              label-align="left">
                                    <select2 v-model="searchForm.status" :options="listStatuses"
                                             style="width:100%"
                                             allowClear="true"
                                             placeholder="--- Tất cả ---"></select2>
                                </b-form-group>
                            </b-col>
                            <b-col sm="6" v-if="showAdministrativeLevel">
                                <b-form-group label="Cấp hành chính:"
                                              label-for="input-unit"
                                              :label-cols-md="4"
                                              :horizontal="true"
                                              label-align="left">
                                    <b-form-radio-group v-model="searchForm.administrativeLevel"
                                                        name="administrative-level-radio-sub-component">
                                        <b-form-radio :value="1">Trung ương</b-form-radio>
                                        <b-form-radio :value="2">Địa phương</b-form-radio>
                                    </b-form-radio-group>
                                </b-form-group>
                            </b-col>
                            <b-col sm="6" v-if="showAdministrativeLevel && showRegion">
                                <b-form-group label="Địa phương:"
                                              label-for="input-unit"
                                              :label-cols-md="4"
                                              :horizontal="true"
                                              label-align="left">
                                    <region-tree v-model="searchForm.regionId"></region-tree>
                                </b-form-group>
                            </b-col>
                            <b-col sm="6" v-if="showHandlingType">
                                <b-form-group label="Hình thức xử lý:"
                                              label-for="input-quantity"
                                              :label-cols-md="4"
                                              :horizontal="true"
                                              label-align="left">
                                    <select2 :options="handlingTypes"
                                             v-model="searchForm.handlingType"
                                             placeholder="--- Tất cả ---"
                                             allowClear="true"></select2>
                                </b-form-group>
                            </b-col>
                            <b-col sm="6" v-if="showInfrastructureAssetType">
                                <b-form-group label="Loại tài sản KCHT:"
                                              label-for="input-quantity"
                                              :label-cols-md="4"
                                              :horizontal="true"
                                              label-align="left">
                                    <select2 :options="infrastructureAssetTypes"
                                             v-model="searchForm.infrastructureAssetType"
                                             placeholder="--- Tất cả ---"
                                             allowClear="true"
                                             class="no-padding"> </select2>
                                </b-form-group>
                            </b-col>
                        </b-row>
                        <b-row>
                            <b-col sm="6">
                                <b-form-group label="Ngày đồng bộ từ:"
                                              label-for="input-startdate"
                                              :label-cols-md="4"
                                              :horizontal="true"
                                              label-align="left">
                                    <date-picker id="input-startdate" v-model="searchForm.syncStartDate" placeholder="dd/mm/yyyy"></date-picker>
                                </b-form-group>
                                <b-form-group label="Ngày báo cáo từ:"
                                              label-for="input-startdate"
                                              :label-cols-md="4"
                                              :horizontal="true"
                                              label-align="left">
                                    <date-picker id="input-startdate" v-model="searchForm.reportStartDate" placeholder="dd/mm/yyyy"></date-picker>
                                </b-form-group>
                            </b-col>
                            <b-col sm="6">
                                <b-form-group label="đến:"
                                              label-for="input-enddate"
                                              :label-cols-md="4"
                                              :horizontal="true"
                                              label-align="left">
                                    <date-picker id="input-enddate" v-model="searchForm.syncEndDate" placeholder="dd/mm/yyyy"></date-picker>
                                </b-form-group>
                                <b-form-group label="đến:"
                                              label-for="input-enddate"
                                              :label-cols-md="4"
                                              :horizontal="true"
                                              label-align="left">
                                    <date-picker id="input-enddate" v-model="searchForm.reportEndDate" placeholder="dd/mm/yyyy"></date-picker>
                                </b-form-group>
                            </b-col>
                        </b-row>
                        <b-row class="justify-content-sm-center">
                            <b-col sm="6">
                                <b-form-group label="" :label-cols="4">
                                    <b-button type="submit" variant="primary">Tìm kiếm</b-button>
                                </b-form-group>
                            </b-col>
                        </b-row>
                    </b-form>
                    <b-grid :searchForm="searchForm"
                            :gridOptions="gridOptions"
                            dataUrl="logging/report-sync-logs"
                            :gridName="gridName"
                            ref="reportSyncLogTable">
                        <template v-slot:cell(syncDate)="row">
                            {{ row.item.syncDate | formatTime }}
                        </template>
                        <template v-slot:cell(reportDate)="row">
                            {{ getReportDate(row.item) }}
                        </template>
                        <template v-slot:cell(reportTypeId)="row">
                            {{ $store.getters.getReportSyncTypeName(row.item.reportTypeId) }}
                        </template>
                        <template v-slot:cell(handlingType)="row">
                            {{ row.item.handlingType ? (handlingTypes[row.item.handlingType - 1] || {}).text : '' }}
                        </template>
                        <template v-slot:cell(infrastructureType)="row">
                            {{ row.item.infrastructureAssetType ? (infrastructureAssetTypes[row.item.infrastructureAssetType - 1] || {}).text : '' }}
                        </template>
                        <template v-slot:cell(actionType)="row">
                            {{ $store.getters.getActionName(row.item.actionType) }}
                        </template>
                        <template v-slot:cell(syncSourceType)="row">
                            {{ $store.getters.getSyncSourceType(row.item.syncSourceType) }}
                        </template>
                        <template v-slot:cell(status)="row">
                            <span :class="row.item.status? 'text-success' : 'text-danger'">
                                {{ $store.getters.getStatusName(row.item.status ? 1 : 0) }}
                            </span>
                        </template>
                        <template v-slot:cell(errorMessage)="row">
                            <button size="sm" @click="showError(row.item, row.index, $event.target)" class="btn mr-2" style="box-shadow: none" v-if="row.value">
                                <i class="fa fa-exclamation-triangle" style="color: orangered" title="Xem chi tiết"></i>
                            </button>
                        </template>
                        <template v-slot:cell(_actions)="row">
                            <b-button size="sm" :to="{ path: `./${row.item.id}` }" title="xem" variant="info">
                                Xem
                            </b-button>
                        </template>
                    </b-grid>
                </b-card>
            </b-col>
        </b-row>

        <!-- Info modal -->
        <b-modal :no-enforce-focus="true" :id="infoModal.id" :title="infoModal.title" ok-only>
            <json-viewer :data="infoModal.content"></json-viewer>
        </b-modal>
    </div>
</template>
<script>
    import { mapState } from 'vuex'
    import { mixins } from '@/shared/mixins'

    export default {
        name: 'ListAssetSource',
        mixins: [mixins],
        data() {
            return {
                listActors: [],
                showUnitOption: false,
                showStatusOption: false,
                title: 'Tra cứu, tìm kiếm nhật ký đồng bộ Báo cáo',
                gridName: 'Danh sách nhật ký đồng bộ báo cáo',
                searchForm: {
                    syncUnitId: this.getUnitTreeIdCache(this.getSyncSourceTypeCache()),
                    unitTraversalOption: this.getUnitTreeTraversalOptionCache(),
                    syncActionType: null,
                    syncSourceType: this.getSyncSourceTypeCache(),
                    reportType: null,
                    syncStartDate: null, //new Date().firstDayOfMonth().formatDate(),
                    syncEndDate: new Date().formatDate(),
                    reportStartDate: null,
                    reportEndDate: new Date().formatDate(),
                    status: null,
                    administrativeLevel: null,
                    regionId: null,
                    handlingType: null,
                    infrastructureAssetType: null,
                },
                gridOptions: {
                    fields: [
                        { key: 'syncUnitName', label: 'Đơn vị đồng bộ', sortable: true, tdAttr: (key, value, item) => ({ title: item.syncUnitFullName }) },
                        { key: 'syncDate', label: 'Ngày đồng bộ', sortable: true, thAttr: { width: 160 } },
                        { key: 'syncSourceType', label: 'Phần mềm đồng bộ', sortable: true },
                        { key: 'assetTypeGroupName', label: 'Nhóm tài sản lớn', sortable: true },
                        { key: 'reportDate', label: 'Ngày báo cáo', sortable: false, thAttr: { width: 100 } },
                        { key: 'reportTypeId', label: 'Mẫu báo cáo', sortable: true },
                        { key: 'regionName', label: 'Địa bàn', sortable: true, class: 'd-none' },
                        { key: 'handlingType', label: 'Hình thức xử lý', sortable: true, class: 'd-none' },
                        { key: 'infrastructureType', label: 'Loại tài sản KCHT', sortable: true, class: 'd-none' },
                        //{ key: 'actionType', label: 'Loại hành vi', sortable: true },
                        { key: 'status', label: 'Trạng thái', sortable: true },
                        { key: 'errorMessage', label: 'Thông báo', sortable: false/*, tdClass: 'text-danger'*/ }
                    ],
                    sortBy: 'syncDate',
                    sortDesc: true
                },
                handlingTypes: [
                    { id: 1, text: "Bán" },
                    { id: 2, text: "Thanh lý" },
                    { id: 3, text: "Điều chuyển" },
                    { id: 4, text: "Thu hồi" },
                    { id: 5, text: "Sử dụng tài sản để thanh toán cho nhà đầu tư theo hình thức BT" },
                    { id: 6, text: "Bị mất / bị hủy hoại" },
                    { id: 7, text: "Hình thức xử lý khác" },
                ],
                infrastructureAssetTypes: [
                    { id: 1, text: "Công trình cấp nước sạch" },
                    { id: 2, text: "Tài sản KCHT thủy lợi" },
                    { id: 3, text: "Tài sản KCHT giao thông đường thủy nội địa" },
                    { id: 4, text: "Tài sản KCHT giao thông đường bộ" },
                    { id: 5, text: "Tài sản KCHT đường sắt quốc gia" },
                    { id: 6, text: "Tài sản KCHT hàng không" },
                    { id: 7, text: "Tài sản KCHT hàng hải" },
                    { id: 8, text: "Tài sản KCHT khác" },
                ],
                infoModal: {
                    id: 'info-modal',
                    title: '',
                    content: ''
                }
            }
        },
        computed: {
            ...mapState({
                listActions: (state) => state.common.listActions,
                listStatuses: (state) => state.common.listStatuses
            }),
            listReportSyncTypes() {
                if (this.$route.meta.reportTypes) {
                    var types = JSON.parse(JSON.stringify(this.$store.state.common.listReportSyncTypes));

                    return types.filter(x => this.$route.meta.reportTypes.indexOf(x.id) != -1);
                } else {
                    return this.$store.state.common.listReportSyncTypes;
                }
            },
            showAdministrativeLevel() {
                return this.searchForm.reportType == 42 || this.searchForm.reportType == 43; // Báo cáo cung cấp thông tin tài chính
            },
            showRegion() {
                return this.showAdministrativeLevel && this.searchForm.administrativeLevel == 2;
            },
            showHandlingType() {
                return this.searchForm.reportType == 26; // Báo cáo mẫu 08c-ĐK/TSKCHT (Phần 01)
            },
            showInfrastructureAssetType() {
                return this.searchForm.reportType == 27; // Báo cáo mẫu 08c-ĐK/TSKCHT (Phần 02)
            }
        },
        created() {
            if (this.$route.meta.unitOption != undefined) {
                this.searchForm.unitTraversalOption = this.$route.meta.unitOption;
            } else {
                this.showUnitOption = true;
            }

            if (this.$route.meta.errorOnly) {
                this.searchForm.status = false;
                //this.searchForm.syncUnitId = this.$store.state.identity.unitId;
            } else {
                this.showStatusOption = true;
            }

            if (this.$route.meta.title) {
                this.title = this.$route.meta.title;
            }

            if (this.$route.meta.gridName) {
                this.gridName = this.$route.meta.gridName;
            }
        },
        methods: {
            showError(item, index, button) {
                this.infoModal.title = `Thông tin lỗi đồng bộ`;
                this.infoModal.content = item.errorMessage;
                this.$root.$emit('bv::show::modal', this.infoModal.id, button);
            },
            search() {
                if (this.showRegion) {
                    this.gridOptions.fields.find(x => x.key == 'regionName').class = '';
                } else {
                    this.gridOptions.fields.find(x => x.key == 'regionName').class = 'd-none';
                }

                if (this.showHandlingType) {
                    this.gridOptions.fields.find(x => x.key == 'handlingType').class = '';
                } else {
                    this.gridOptions.fields.find(x => x.key == 'handlingType').class = 'd-none';
                }

                if (this.showInfrastructureAssetType) {
                    this.gridOptions.fields.find(x => x.key == 'infrastructureType').class = '';
                } else {
                    this.gridOptions.fields.find(x => x.key == 'infrastructureType').class = 'd-none';
                }

                this.$refs.reportSyncLogTable.refresh();
            },
            getReportDate(report) {
                var reportType = this.$store.getters.getReportSyncType(report.reportTypeId);
                var format = defaultDisplayFormatDate;
                switch (reportType.periodType) {
                    case 1: return formatDate(report.reportEndDate, format);
                    case 2: return `${formatDate(report.reportStartDate, format)} - ${formatDate(report.reportEndDate, format)}`;
                    case 3: return report.reportYear ? `31/12/${report.reportYear}` : '';
                }
            }
        }
    }
</script>
<style scoped>
</style>
